// Sidebar.js

const Sidebar = () => (
    <aside>
      <p>Hi, I’m Elliot.</p>
      <p> 🏡 Brooklyn, NY </p>
      <p> 🧑🏻‍💻 Technical product management</p>
      <p> 📖 Genomics, Climate, Philosophy</p>
      <p> 🖊 Policy implications of emerging tech</p>
    </aside>
  );
  
  export default Sidebar;
  